import { MapTilerBaseLayerBase } from "./MapTilerBaseLayerBase";
export class DarkMapLayer extends MapTilerBaseLayerBase {
    constructor() {
        super(DarkMapLayer.Url);
    }
    onAfterFetch(style) {
        // update oneway arrows.
        MapTilerBaseLayerBase.removeLayers(style, ["road_oneway", "road_oneway_opposite"]);
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "text-font": [],
                "icon-image": "oneway",
                "visibility": "visible",
                "icon-rotate": 90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 0.5
            },
            filter: MapTilerBaseLayerBase.IsOnewayFilter()
        }, "highway-name-path");
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway-reverse",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "text-font": [],
                "icon-image": "oneway",
                "visibility": "visible",
                "icon-rotate": -90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 0.5
            },
            filter: MapTilerBaseLayerBase.IsOnewayReverseFilter()
        }, "road-oneway");
    }
}
DarkMapLayer.Url = "https://api.maptiler.com/maps/83619329-11c4-49a8-a0e4-88caeaefbf68/style.json?key=OZUCIh4RNx38vXF8gF4H";
